export enum OAuthProviderURI {
  DOR_DTM = 'constellation.com.getdor.dtm',
  TWITTER_X = 'twitter.com',
  GOOGLE = 'google.com',
}
